export default {
  methods: {
    calcTaskListHours(list) {
      let hrs = 0;
      for (var i = 0; i < list.length; i++) {
        hrs = hrs + parseFloat(list[i].char.hrs);
      }
      return hrs;
    },
    calcTaskListHoursActual(list) {
      let hrs = 0;
      for (var i = 0; i < list.length; i++) {
        hrs = hrs + parseFloat(list[i].char.hrsa);
      }
      return hrs;
    },
    calcTaskListPersonRoles(list) {
      let ctr = 0;
      let chk = "";
      for (var i = 0; i < list.length; i++) {
        if (chk !== list[i].char.resr) {
          chk = list[i].char.resr;
          ctr = ctr + 1;
        }
      }
      return ctr;
    },
    calcTaskListCounterBasedOnStatus(type, list) {
      let ctr = 0;
      for (var i = 0; i < list.length; i++) {
        if (type === list[i].char.status) {
          ctr = ctr + 1;
        }
      }
      return ctr;
    },
    calcTaskListProgress(list) {
      let per = null;
      if (list !== undefined && list !== null) {
        if (list.length > 0) {
          let done = this.calcTaskListCounterBasedOnStatus("Done", list);
          let issue = this.calcTaskListCounterBasedOnStatus("Issue", list);
          let total = list.length;
          // eslint-disable-next-line
          per = (done + issue) / total;
          per = per * 100;
          per = per.toFixed(1);
        } else {
          per = 0;
        }
      } else {
        per = 0;
      }
      return per;
    },
    calcTaskListCompliance(list) {
      let per = 0;
      let done = this.calcTaskListCounterBasedOnStatus("Done", list);
      let total = list.length;
      // eslint-disable-next-line
      per = done/total;
      per = per * 100;
      per = per.toFixed(1);
      return per;
    },
    calcTaskListParts(list) {
      let ctr = 0;
      let chk = "";
      for (var i = 0; i < list.length; i++) {
        if (chk !== list[i].char.part) {
          chk = list[i].char.part;
          ctr = ctr + 1;
        }
      }
      return ctr;
    },
    calcTaskListPersonHours(list) {
      let ph = 0;
      for (var i = 0; i < list.length; i++) {
        ph = ph + parseFloat(list[i].char.hrs) * parseFloat(list[i].char.per);
      }
      return ph;
    },
    calcTaskPersonHours(per, hrs) {
      let ph = 0;
      ph = parseFloat(per) * parseFloat(hrs);
      ph = ph.toFixed(1);
      return ph;
    }
  }
};
